import React from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager'
import { Accordion as UIFoundationsAccordion } from '@dcxwam/dcx-wam-ui-foundations'
import Container from '../../templates/Container/Container'
import AccordionItemEditConfig from './AccordionItemEditConfig'
import { AccordionItemModelProps } from './types'
import { EditableComponentPropsType } from '../../../utils/prop-types'
import withComponentRefresh from '../../../utils/aem/editor/withComponentRefresh'
import { useExtractEditableProps } from '../../../utils/aem/editor/extractEditableProps'
import EditionWrapper from '../../templates/EditionWrapper'
import {
  WithAutomaticTestIdsType,
  withAutomaticTestIds
} from '../../../utils/aem/with-automatic-test-ids'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../functional/ErrorBoundary'

const AccordionItem = withComponentRefresh(
  withAutomaticTestIds(
    (
      props: WithAutomaticTestIdsType<
        EditableComponentPropsType<AccordionItemModelProps>
      >
    ) => {
      const {
        id,
        title,
        imagePath,
        imageHeight,
        imageWidth,
        imgAlt,
        imageSrcSet,
        ...rest
      } = props.model
      const { getDataTestIdObject } = props
      const editableProps = useExtractEditableProps(props, rest)
      const accordionConfig = {
        items: [
          {
            titleProps: {
              title: title || '',
              imageProps: {
                src: imagePath,
                height: imageHeight,
                width: imageWidth,
                imageAlt: imgAlt,
                imageSrcSetData: imageSrcSet
              }
            }
          }
        ],
        ...getDataTestIdObject('accordion-item', id)
      }

      return (
        <EditableComponent {...editableProps}>
          {AccordionItemEditConfig.isEmpty(props)
            ? AccordionItemEditConfig.emptyLabel
            : null}
          {!AccordionItemEditConfig.isEmpty(props) &&
            (AuthoringUtils.isInEditor() ? (
              <EditionWrapper label={AccordionItemEditConfig.emptyLabel}>
                <UIFoundationsAccordion {...accordionConfig} />
                <Container {...props} />
              </EditionWrapper>
            ) : null)}
        </EditableComponent>
      )
    }
  )
)

const AccordionItemWithErrorBoundary = withErrorBoundary(AccordionItem, {
  componentName: 'AccordionItem',
  fallback: <ErrorFallback componentName="AccordionItem" />
})

export default AccordionItemWithErrorBoundary
